
import { defineComponent, ref, inject, watch, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "ProfessionalSummary",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isPitchDeckUrl = ref<string>('0');
    const store = useStore();
    const firstTime = ref<boolean>(false);
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    watch(
      () => props.formDataTemp,
      (value) => {
        formData.value = { ...value };
        if (!firstTime.value) {
          isPitchDeckUrl.value = eval(value?.isPitchDeckUrl ?? 0)
          file.value = value?.pitchDeckDocument ?? null;
        }
        firstTime.value = true;
      }
    );
    const document = ref<string | unknown>("");
    const fileSizeError = ref<boolean>(false);
    const file = ref<string | null>(null);
    const handleImageUpload = async (event) => {
      fileSizeError.value = false;
      emit("file-size-error", false);
      try {
        const file = event.target.files[0];
        var fileSize = +(file.size / 1024 / 1024).toFixed(4);
        if (fileSize > 10) {
          fileSizeError.value = true;
          emit("file-size-error", true);
          file.value = null;
          return;
        }
        const formDataFile = new FormData();
        formDataFile.append("file", file);
        emit("loading", true);
        const response = await store.dispatch(
          Actions.UPLOAD_FILE,
          formDataFile
        );
        emit("loading", false);
        if (!response.includes("https://")) throw new Error("error in api");
        const tempEvent = {
          target: {
            name: event.target.name,
            value: response,
          },
        };
        fieldChanged(tempEvent);
        const res = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
          business: JSON.stringify(formData.value),
        });
        if (res !== true) throw new Error("error in API");
      } catch (err) {
        emit("loading", false);
        console.log({ err });
      }
    };
    const fieldChanged = async (event) => {
      formData.value[event.target.name] = event.target.value;
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
      try {
        const res = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
          business: JSON.stringify(formData.value),
        });
        if (res !== true) throw new Error("error in API");
      } catch (err) {
        console.log(err);
      }
    };
    return {
      isPitchDeckUrl,
      document,
      formData,
      fieldChanged,
      handleImageUpload,
      fileSizeError,
      file,
    };
  },
});
